// store/slices/snackbarSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SnackbarState {
    open: boolean;
    message: string;
    severity: "success" | "error" | "info" | "warning";
    autoHideDuration?: number;
}

const initialState: SnackbarState = {
    open: false,
    message: "",
    severity: "info",
    autoHideDuration: 4000,
};

const snackbarSlice = createSlice({
    name: "snackbar",
    initialState,
    reducers: {
        showSnackbar(state, action: PayloadAction<Partial<SnackbarState>>) {
            state.open = true;
            state.message = action.payload.message || "";
            state.severity = action.payload.severity || "info";
            state.autoHideDuration = action.payload.autoHideDuration || 4000;
        },
        closeSnackbar(state) {
            state.open = false;
        },
    },
});

export const { showSnackbar, closeSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
